module.exports = __webpack_public_path__ + "static/media/qty-plus-brand-refresh.15501ed8.svg";